import styled from 'styled-components'

export const DefaultLink = styled.a`
  cursor: pointer;
`
